import styled from 'styled-components';
import { HomeRoot } from '../public-home/PublicHomePage.styles';

/*
 * Página "Indique lojistas" (/indicacao, visitante).
 * Porte do css/indicacao.css do pacote canal-do-repasse-home-aspx_1, complementando
 * o HomeRoot (tokens, .cr-header, .cr-btn, .cr-field, .cr-eyebrow, .cr-footer).
 */
export const IndicacaoRoot = styled(HomeRoot)`
	/* ---------- Hero ---------- */
	.cr-ind-hero {
		position: relative;
		/* clip (e nao hidden): recorta sem virar container de rolagem, mantendo o sticky */
		overflow: clip;
		background: #ffffff;
	}
	.cr-ind-hero__grid {
		position: relative;
		display: grid;
		grid-template-columns: minmax(0, 360px) minmax(0, 1fr) minmax(0, 362px);
		column-gap: 20px;
		/* Hero de altura fixa (como a referencia): texto centralizado, foto e painel
		   ocupam a mesma altura. O formulario rola DENTRO do painel. */
		align-items: stretch;
		height: 540px;
	}
	.cr-ind-copy {
		position: relative;
		z-index: 3;
		display: flex;
		flex-direction: column;
		justify-content: center;
		gap: 22px;
		padding: 40px 0;
	}
	.cr-ind-copy .cr-hero__title {
		font-size: 34px;
		white-space: nowrap;
	}
	.cr-ind-copy .cr-hero__text {
		max-width: 360px;
		font-size: 15px;
	}
	.cr-benefits {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		margin-top: 34px;
	}
	.cr-benefits > div {
		display: flex;
		flex-direction: column;
		gap: 14px;
		padding: 4px 18px 4px 0;
		margin-right: 18px;
		border-right: 1px solid var(--cr-line);
	}
	.cr-benefits > div:last-child {
		border-right: 0;
		margin-right: 0;
	}
	.cr-benefits svg {
		width: 34px;
		height: 34px;
		color: var(--cr-orange);
	}
	.cr-benefits b {
		font: 600 13.5px/1.45 Inter, sans-serif;
		color: var(--cr-ink);
	}

	.cr-ind-photo {
		position: relative;
		min-width: 0;
		margin-left: 0;
		z-index: 1;
	}
	.cr-ind-photo img {
		position: absolute;
		inset: 0;
		display: block;
		width: 100%;
		height: 100%;
		object-fit: contain;
		object-position: right bottom;
	}

	/* ---------- Painel de indicação ---------- */
	.cr-ind-form {
		position: relative;
		z-index: 2;
		/* mesma altura do hero, com respiro igual em cima e embaixo (alinhado a foto) */
		align-self: stretch;
		width: 100%;
		min-height: 0;
		margin: 20px 0;
		overflow: hidden;
		background: #ffffff;
		border: 1px solid var(--cr-line);
		border-radius: 14px;
		padding: 20px 22px 18px;
		box-shadow: 0 12px 34px rgba(20, 20, 20, 0.08);
		display: flex;
		flex-direction: column;
		gap: 8px;
	}
	.cr-ind-form__title {
		font: 600 21px Inter, sans-serif;
		letter-spacing: -0.02em;
		margin: 0;
	}
	.cr-ind-form__sub {
		margin: 0;
		font: 400 12px/1.4 Inter, sans-serif;
		color: var(--cr-muted);
	}
	.cr-ind-form__fields {
		display: flex;
		flex-direction: column;
		gap: 8px;
		/* o formulario rola dentro do painel; titulo e subtitulo ficam fixos */
		flex: 1 1 auto;
		min-height: 0;
		overflow-y: auto;
		overscroll-behavior: contain;
		padding-right: 8px;
		margin-right: -8px;
		scrollbar-width: thin;
		scrollbar-color: #d9d9d6 transparent;
	}
	.cr-ind-form__fields::-webkit-scrollbar {
		width: 6px;
	}
	.cr-ind-form__fields::-webkit-scrollbar-thumb {
		background: #d9d9d6;
		border-radius: 999px;
	}
	.cr-ind-form__fields::-webkit-scrollbar-track {
		background: transparent;
	}
	.cr-ind-block {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}
	.cr-ind-block + .cr-ind-block {
		margin-top: 6px;
		padding-top: 8px;
		border-top: 1px solid var(--cr-line);
	}
	.cr-ind-block__title {
		margin: 0;
		font: 600 12px Inter, sans-serif;
		letter-spacing: 0.04em;
		text-transform: uppercase;
		color: var(--cr-ink);
	}
	.cr-ind-hint {
		display: block;
		margin-top: 4px;
		font: 400 11.5px/1.4 Inter, sans-serif;
		color: var(--cr-muted);
	}
	.cr-ind-form .cr-group {
		margin-bottom: 0;
		min-width: 0;
	}
	.cr-ind-form .cr-field {
		height: 36px;
		font-size: 12.5px;
		padding: 0 12px;
	}
	.cr-ind-form select.cr-field {
		padding-right: 32px;
		background-position: right 10px center;
	}
	.cr-ind-form .cr-field--area {
		height: 52px;
		padding: 8px 12px;
	}
	.cr-ind-form .cr-label {
		font-size: 11.5px;
		margin-bottom: 4px;
	}
	.cr-ind-row {
		display: grid;
		gap: 10px;
	}
	.cr-ind-row--2 {
		grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
	}
	.cr-ind-row--cep {
		grid-template-columns: minmax(0, 110px) minmax(0, 1fr);
	}
	.cr-ind-row--uf {
		grid-template-columns: minmax(0, 88px) minmax(0, 1fr);
	}
	.cr-ind-row--city {
		grid-template-columns: minmax(0, 1fr) minmax(0, 88px);
	}

	.cr-tipo {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 10px;
	}
	.cr-tipo__btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		height: 36px;
		border-radius: 8px;
		border: 1px solid var(--cr-line);
		background: #f7f7f5;
		color: var(--cr-ink);
		font: 500 13px Inter, sans-serif;
		cursor: pointer;
	}
	.cr-tipo__btn svg {
		width: 16px;
		height: 16px;
	}
	.cr-tipo__btn.is-active {
		background: var(--cr-orange);
		border-color: var(--cr-orange);
		color: #ffffff;
		font-weight: 600;
	}
	.cr-tipo__btn:focus-visible {
		outline: 2px solid var(--cr-ink);
		outline-offset: 2px;
	}
	.cr-tipo__btn:disabled {
		opacity: 0.7;
		cursor: not-allowed;
	}
	.cr-ind-submit-wrap {
		display: block;
		align-self: stretch;
		width: 100%;
		min-width: 0;
		box-sizing: border-box;
	}
	.cr-ind-submit {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		width: 100%;
		max-width: 100%;
		height: 36px;
		margin-top: 8px;
		padding: 0 12px;
		box-sizing: border-box;
		border: 0;
		border-radius: 8px;
		background: var(--cr-orange);
		color: #ffffff;
		font: 600 12.5px/1 Inter, sans-serif;
		cursor: pointer;
		transition: background 0.15s;
	}
	.cr-ind-submit:hover,
	.cr-ind-submit:focus-visible {
		background: var(--cr-orange-hover);
		color: #ffffff;
	}
	.cr-ind-submit:focus-visible {
		outline: 2px solid var(--cr-orange);
		outline-offset: 3px;
	}
	.cr-ind-submit:disabled {
		opacity: 0.7;
		cursor: not-allowed;
	}
	.cr-ind-submit .cr-arrow {
		width: 16px;
		height: 16px;
		flex-shrink: 0;
		color: #ffffff;
	}
	/* CTA do cabecalho (Cadastrar Indicacao) com texto branco */
	.cr-header .cr-btn,
	.cr-header .cr-btn:hover,
	.cr-header .cr-btn:focus-visible {
		color: #ffffff;
	}
	.cr-ind-form__lgpd {
		margin: 0;
		font: 400 10.5px/1.4 Inter, sans-serif;
		color: var(--cr-muted);
	}
	.cr-ind-form__lgpd a {
		color: var(--cr-orange-dark);
	}
	.cr-ind-notice {
		margin: 0;
		padding: 10px 12px;
		border-radius: 8px;
		background: #fff7f0;
		border: 1px solid #ffd9bd;
		font: 400 12.5px/1.5 Inter, sans-serif;
		color: var(--cr-text);
	}
	.cr-ind-notice b {
		display: block;
		margin-bottom: 2px;
		color: var(--cr-ink);
	}
	.cr-ind-notice .cr-btn {
		margin-top: 8px;
		height: 38px;
		font-size: 13px;
	}
	.cr-ind-done {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 12px;
		padding: 8px 0;
	}
	.cr-ind-done svg {
		width: 40px;
		height: 40px;
		color: var(--cr-orange);
	}
	.cr-ind-done h3 {
		margin: 0;
		font: 600 20px Inter, sans-serif;
		letter-spacing: -0.02em;
	}
	.cr-ind-done p {
		margin: 0;
		font: 400 14px/1.5 Inter, sans-serif;
		color: var(--cr-muted);
	}

	/* ---------- Como funciona ---------- */
	.cr-steps {
		padding: 56px 0 60px;
		background: #ffffff;
		border-top: 1px solid var(--cr-line);
	}
	.cr-steps__in {
		display: grid;
		grid-template-columns: minmax(0, 360px) minmax(0, 1fr);
		column-gap: 40px;
		align-items: start;
	}
	.cr-steps__title {
		margin: 14px 0 0;
		font: 700 38px/1.1 Inter, sans-serif;
		letter-spacing: -0.03em;
		color: var(--cr-ink);
	}
	.cr-steps__title em {
		font-style: normal;
		color: var(--cr-orange);
	}
	.cr-steps__items {
		display: grid;
		grid-template-columns: repeat(4, minmax(0, 1fr));
		column-gap: 0;
		list-style: none;
		margin: 0;
		padding: 0;
	}
	.cr-step {
		position: relative;
		padding: 0 28px 0 0;
		margin-right: 28px;
	}
	.cr-step::after {
		content: '';
		position: absolute;
		right: -6px;
		top: 16px;
		width: 8px;
		height: 8px;
		border-right: 1.5px solid #c9c9c5;
		border-top: 1.5px solid #c9c9c5;
		transform: rotate(45deg);
	}
	.cr-step:last-child {
		margin-right: 0;
		padding-right: 0;
	}
	.cr-step:last-child::after {
		display: none;
	}
	.cr-step__top {
		display: flex;
		align-items: center;
		gap: 10px;
		margin-bottom: 14px;
	}
	.cr-step__num {
		font: 300 36px/1 Inter, sans-serif;
		color: #d6d6d3;
		letter-spacing: -0.02em;
	}
	.cr-step__top svg {
		width: 26px;
		height: 26px;
		color: var(--cr-orange);
	}
	.cr-step b {
		display: block;
		font: 600 14px Inter, sans-serif;
		margin-bottom: 8px;
	}
	.cr-step span {
		font: 400 13.5px/1.6 Inter, sans-serif;
		color: var(--cr-muted);
	}

	/* ---------- Responsivo ---------- */
	@media (max-width: 1180px) {
		.cr-ind-hero__grid {
			grid-template-columns: minmax(0, 400px) minmax(0, 1fr) minmax(0, 360px);
		}
		.cr-ind-copy .cr-hero__title {
			font-size: 36px;
			white-space: normal;
		}
	}
	@media (max-width: 1024px) {
		.cr-ind-hero__grid {
			grid-template-columns: minmax(0, 1fr) minmax(0, 370px);
			row-gap: 0;
		}
		.cr-ind-copy .cr-hero__title {
			font-size: 34px;
			white-space: normal;
		}
		.cr-ind-hero__grid {
			height: auto;
			min-height: 0;
		}
		.cr-ind-copy {
			justify-content: flex-start;
			padding: 40px 0 24px;
		}
		.cr-ind-form {
			overflow: visible;
		}
		.cr-ind-form__fields {
			overflow: visible;
			padding-right: 0;
			margin-right: 0;
		}
		.cr-ind-photo {
			grid-column: 1 / -1;
			order: 3;
			height: auto;
			margin: 0 0 24px;
			display: flex;
			justify-content: center;
		}
		.cr-ind-photo img {
			position: static;
			width: min(100%, 460px);
			height: auto;
			object-fit: contain;
			border-radius: 12px;
		}
		.cr-steps__in {
			grid-template-columns: minmax(0, 1fr);
			row-gap: 28px;
		}
		.cr-steps__items {
			grid-template-columns: repeat(2, minmax(0, 1fr));
			row-gap: 28px;
		}
		.cr-step:nth-child(2)::after {
			display: none;
		}
	}
	@media (max-width: 720px) {
		.cr-ind-hero__grid {
			grid-template-columns: minmax(0, 1fr);
		}
		.cr-ind-copy {
			padding: 36px 0 8px;
		}
		.cr-ind-copy .cr-hero__title {
			font-size: 32px;
			white-space: normal;
		}
		.cr-benefits {
			grid-template-columns: minmax(0, 1fr);
			margin-top: 20px;
		}
		.cr-benefits > div {
			flex-direction: row;
			align-items: center;
			gap: 14px;
			border-right: 0;
			border-bottom: 1px solid var(--cr-line);
			padding: 12px 0;
			margin: 0;
		}
		.cr-benefits > div:last-child {
			border-bottom: 0;
		}
		.cr-benefits svg {
			width: 28px;
			height: 28px;
			flex-shrink: 0;
		}
		.cr-ind-photo {
			order: 2;
			margin: 8px 0 0;
		}
		.cr-ind-form {
			order: 3;
			margin: 12px 0 32px;
			padding: 22px 18px;
		}
		.cr-ind-form__fields {
			max-height: none;
		}
		.cr-ind-row--2,
		.cr-ind-row--cep,
		.cr-ind-row--uf {
			grid-template-columns: minmax(0, 1fr);
		}
		.cr-ind-row--city {
			grid-template-columns: minmax(0, 1fr) minmax(0, 96px);
		}
		.cr-steps {
			padding: 40px 0;
		}
		.cr-steps__title {
			font-size: 30px;
		}
		.cr-steps__items {
			grid-template-columns: minmax(0, 1fr);
			row-gap: 24px;
		}
		.cr-step {
			margin: 0;
			padding: 0;
		}
		.cr-step::after {
			display: none;
		}
	}
`;
